// ✅ Spanish translations for the account section

const accountES = {
    comingSoon: "Próximamente",

    menu: {
        bookings: "Citas",
        favorites: "Favoritos",
        reviews: "Reseñas",
        notifications: "Notificaciones",
        language: "Idioma",
        security: "Seguridad",
        privacy: "Política de Privacidad",
        terms: "Términos de Servicio",
        refund: "Política de Reembolso",
        contact: "Contacto",
        helpandsupport: "Ayuda y Soporte",
        reportsandperfomance: "Reportes y Rendimiento",
        marketing: "Marketing",
        category: "Categorías",
        referral: "Referidos",
        billing: "Facturación",
        logout: "Cerrar Sesión",
        about: "Acerca de"
    },

    language: {
        title: "Idioma",
        current: "Idioma actual",
    },

    header: {
        title: "Cuenta",
        back: "Atrás",
    },

    emptyState: {
        title: "Tu Cuenta",
        description: "Selecciona una opción del menú para ver tus citas, favoritos o configuración.",
    },

    bookings: {
        title: "Citas",
        subtitleUpcoming: (count) => `${count} próximas`,
        noUpcoming: "No tienes citas próximas",
        noHistory: "Aún no hay citas pasadas",
        historyTitle: "Historial",
        cancel: "Cancelar",
        reschedule: "Reprogramar",
        confirmed: "confirmada",
        cancelled: "cancelada",
        addToCalendar: "Agregar al Calendario",
        emailSent: "Correo enviado",
        confirmCancelTitle: "Cancelar cita",
confirmCancelText: "¿Estás seguro de que deseas cancelar esta cita? Esta acción no se puede deshacer.",
confirmCancelNo: "Mantener cita",
confirmCancelYes: "Sí, cancelar",
    },

    favorites: {
        title: "Favoritos",
        empty: "Todavía no has agregado ningún favorito.",
    },

    reviews: {
        title: "Mis Reseñas",
        empty: "Aún no has escrito ninguna reseña.",
        rating: "Calificación",
    },

    settings: {
        title: "Cuenta y Configuración",
        comingSoon: "La configuración estará disponible pronto.",
    },

    status: {
        confirmed: "Confirmado",
        cancelled: "Cancelado",
        pending: "Pendiente",
    },

    notifications: {
        title: "Notificaciones",
        emailLabel: "Correo",
		pushLabel: "Push",
        sections: {
            bookings: "Reservas",
            reviews: "Reseñas",
            reminders: "Recordatorios",
            shop: "Negocio",
        },

        items: {
            bookings: "Nuevas reservas",
            reschedule: "Reservas reprogramadas",
            cancellation: "Reservas canceladas",
            reminder24h: "24 horas antes de la reserva",
            reminder1h: "1 hora antes de la reserva",
            reviews: "Nuevas reseñas",
            shopBookings: "Nuevas reservas para mi equipo",
            shopUpdates: "Actualizaciones y anuncios del negocio",
        },

        push: "Notificaciones Push",
        pushEnabled: "Las notificaciones push están activadas en este dispositivo.",
        pushCtaTitle: "Activar notificaciones push",
        pushCtaHint: "Recibe alertas en tiempo real en tu teléfono.",
    },

    categories: {
        title: "Categoría del negocio",
        category: "Categoría",
        subCategory: "Subcategoría",
        select: "Seleccionar",
        save: "Guardar",
        saving: "Guardando…",
    },

    referral: {
        title: "Programa de Referidos",

        statusLabels: {
            pending_billing: "Esperando primer pago",
            pending_referrer_payment: "Esperando el primer pago del referidor",
            reward_issued: "Descuento aplicado ✓",
        },

        hero: {
            title: "Ahorra $15 USD por referido",
            subtitle:
                "Invita a otros negocios a Sin Fila. Cada referido activo te da $15 de descuento en tu próxima factura.",
            earned: (amount) => `Has ahorrado $${amount} hasta ahora`,
        },

        code: {
            label: "Tu código de referido",
            copy: "Copiar código",
        },

        link: {
            label: "Comparte tu enlace",
            copy: "Copiar enlace",
        },

        hint: "Los descuentos se aplican automáticamente cuando el negocio referido activa su facturación.",

        history: {
            title: "Historial de referidos",
            empty: "Aún no tienes referidos",
            pending: "Pendiente",
            active: "Activo",
        },
    },

    contact: {
        title: "Contactar Soporte",
        email: "Correo electrónico",
        phone: "Teléfono (opcional)",
        subject: "Asunto",
        messagePlaceholder: "Tu mensaje...",
        send: "Enviar mensaje",
        sending: "Enviando...",
        success: "Mensaje enviado correctamente",
        errorRequired: "El mensaje es obligatorio",
        errorFailed: "No se pudo enviar el mensaje",
    },
    security: {
        title: "Seguridad",

        emailTitle: "Correo electrónico",
        passwordTitle: "Restablecer contraseña",

        comingSoon: "La configuración de seguridad estará disponible pronto.",
    },

    forgotPassword: {
        subtitle: "Te enviaremos un correo con instrucciones para restablecer tu contraseña.",

        send: "Enviar enlace",
        sending: "Enviando...",

        success: "Correo para restablecer la contraseña enviado correctamente.",

        toast: {
            error: "No se pudo enviar el correo. Inténtalo de nuevo.",
        },
    },
};

export default accountES;
